module.exports = __webpack_public_path__ + "img/logo.2a9d6357.svg";